import styled from 'styled-components';

export const GeneralStudentStyleButton2 = styled.div`
  .button-primary {
    background-color: ${(props) => (props.theme.primary)} !important;
    color: #ffffff
  }


`;
